import React, { useState } from "react";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";
import { convertToYoutubeEmbed } from "../../utilities/convertUrlToYoutubeEmbed";
import { renderContent } from "../../utilities/renderContent";

export default function Video({ data }) {
  console.log(data);
  const [videoClicked, setVideoClicked] = useState(false);
  const { videoTitle, placeholderImage, youtubeEmbedUrl, video } = data;
  return (
    <>
      {videoTitle && (
        <div
          dangerouslySetInnerHTML={renderContent(videoTitle)}
          className="video__title text-2xl md:text-4xl hds-text-color font-heading text-center pt-10"
        />
      )}
      <div className="Video max-w-3xl mx-auto py-16 flex flex-col items-center">
        {videoClicked ? (
          <>
            {video ? (
              <div className="h-auto w-full lg:w-[64rem] pt-8">
                <video controls autoPlay playsInline class="w-full">
                  <source src={video.url} type={`video/${video.format}`} />
                  Your browser does not support the video tag.
                </video>
              </div>
            ) : (
              <div className="video-container w-full">
                <iframe
                  src={convertToYoutubeEmbed(youtubeEmbedUrl)}
                  className="video__iframe"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="Youtube Video"
                  width="560"
                  height="315"
                />
              </div>
            )}
          </>
        ) : (
          <div onClick={() => setVideoClicked(true)}>
            <Image
              className="w-full h-full object-cover object-center"
              image={getImage(placeholderImage)}
              alt={placeholderImage.alt}
            />
          </div>
        )}
      </div>
    </>
  );
}
